import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Combobox from 'react-widgets/lib/Combobox'
import Loader from 'react-loader-spinner';

class Transition extends Component {

    constructor() {
        super();
        this.state = {
            data: [],
            slotValue: {},
            slotValueType: [],
            dsmTransitionTypes: [],
            functionValue: null,
            hideDeletePopup: false,
            editedId: "-1",
            showLoader: false,
            disableAdd: false
        }
        this.columns = [];
        this.transitionData = {};
        this.numOfRendering = 0;
        this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };

        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteApiFunc(this.state.propsId)
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
    }

    componentDidMount() {
        setTimeout(() => {
            this.getSlotValueType();
            this.getDsmTransitionTypes();
            this.getColumns();
            this.loadData();
        }, 300);
        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.goBack();
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    loadData = () => {
        let transitionController = this;
        var loadData = {}
        $.ajax({
            url: "/api/dsm-transition/" + transitionController.props.location.state.dstId,
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    transitionController.state.data = res.result;
                    transitionController.state.showLoader = true;
                    transitionController.state.disableAdd = false;
                    transitionController.setState(transitionController.state);
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }



    getColumns = () => {
        if (this.columns.length > 0) {
            return;
        }
        let transitionController = this;
        let intentId = localStorage.getItem("intentId");
        //  this.props.location.state.intentId;
        var slotNameList = [];
        var slotValueType = transitionController.state.slotValueType;
        $.ajax({
            url: "/api/slots",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: {
                intentId: intentId
            },
            success: function (res) {
                if (res.success === true) {
                    transitionController.state.emptyDataRecord = {};
                    var emptySlotValues = {};

                    for (var i = 0; i < res.result.length; i++) {
                        slotNameList.push({ "name": res.result[i].name });
                        emptySlotValues[res.result[i].name] = "";
                    }
                    transitionController.state.emptyDataRecord.slotStatesMap = emptySlotValues;
                    transitionController.state.emptyDataRecord.transitionFunction = "";


                    transitionController.columns = slotNameList.map((slot) => {
                        return {
                            Header: <b>{slot.name}</b>,
                            accessor: slot.name,
                            sortable: false,
                            minWidth: 20,
                            Cell: props => (
                                <div className="container-fluid">
                                    <Combobox
                                        disabled={(props.original.id == null) ? false : (props.original.id != transitionController.state.editedId)}
                                        data={slotValueType}
                                        visible="false"
                                        textField='name'
                                        caseSensitive={false}
                                        minLength={1}
                                        filter='contains'
                                        name={slot.name}
                                        id={slot.name + props.index}
                                        value={props.original.slotStatesMap ?
                                            props.original.slotStatesMap[slot.name] : ""}
                                        // onSelect={(e) => { this.onSlotValueSelection(props, e) }}
                                        onChange={(e) => transitionController.onSlotValueSelection(props, e)}
                                    />
                                </div>
                            )
                        };
                    });
                    transitionController.columns.push(
                        {
                            Header: <b>function</b>,
                            accessor: 'function',
                            sortable: false,
                            minWidth: 20,
                            Cell: props => (<div>
                                <Combobox
                                    disabled={(props.original.id == null) ? false : (props.original.id != transitionController.state.editedId)}
                                    data={transitionController.state.dsmTransitionTypes}
                                    visible="false"
                                    textField='name'
                                    caseSensitive={false}
                                    minLength={1}
                                    filter='contains'
                                    id={"function" + props.index.id}
                                    value={props.original.transitionFunction}
                                    // onSelect={(e) => this.onFunctionValueSelection(props, e)}
                                    onChange={(e) => transitionController.onFunctionValueSelection(props, e)}
                                /></div>
                            )
                        },
                        {
                            width: 60,
                            Header: <b>priority</b>,
                            accessor: 'priority',
                            sortable: false,
                            Cell: props => (
                                <img className="cursor-change" src="./assets/images/arrow_upward.png"
                                    onClick={(e) => transitionController.changePriorityOfRow(props, e)} />
                            )
                        },
                        {
                            width: 90,
                            Header: <b>manage</b>,
                            accessor: 'manage',
                            sortable: false,
                            Cell: props => (
                                <div style={{ marginTop: "-6px" }}>

                                    {/* Edit/Save Button */}
                                    <button style={{ backgroundColor: "#ffffff", border: "none" }}
                                        title={(props.original.id == undefined) ? "Save" :
                                            ((props.original.id != transitionController.state.editedId)
                                                ? "Edit" : "Save")}>

                                        <img className="img-responsive" id="editOrSave"
                                            style={{
                                                marginTop: '8px', backgroundColor: '#282a65',
                                                borderRadius: '5px', padding: '1px'
                                            }}
                                            src={
                                                (props.original.id == undefined)
                                                    ?
                                                    "./assets/images/baseline_save_white_24dp.png" :

                                                    ((props.original.id != transitionController.state.editedId)
                                                        ?
                                                        "./assets/images/edit2.png" : "./assets/images/baseline_save_white_24dp.png")}
                                            onClick={(e) => {
                                                (props.original.id == undefined)
                                                    ?
                                                    transitionController.saveCell(props, e)
                                                    :
                                                    ((props.original.id == transitionController.state.editedId)
                                                        ?
                                                        transitionController.updateCell(props, e)
                                                        :
                                                        transitionController.editCell(props, e));

                                            }}
                                        />
                                    </button>
                                    {/* Delete Button*/}
                                    <button style={{ backgroundColor: "#ffffff", border: "none" }}
                                        title="Delete">
                                        <img className="img-responsive"
                                            style={{
                                                marginTop: '6px',
                                                backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                            }}
                                            src="./assets/images/baseline_delete_white_24dp.png"
                                            onClick={() => (props.original.id) === null ?
                                                transitionController.loadData() :
                                                transitionController.setState({
                                                    hideDeletePopup: true,
                                                    propsId: props.original.id
                                                })
                                            }
                                        />
                                    </button>
                                </div>

                            )
                        })
                    transitionController.setState({ dataChanged: true });
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onSlotValueSelection = (props, e) => {
        // this.transitionData[props.column.id] = e;
        this.state.data[props.index].slotStatesMap[props.column.id] = e;
        this.setState(this.state);
    }

    onFunctionValueSelection = (props, e) => {
        // this.setState({ functionValue: e });
        this.state.data[props.index].transitionFunction = e;
        this.setState(this.state);
    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });
    }

    addRow = () => {
        var slotStatesMap = this.state.emptyDataRecord.slotStatesMap;
        var emptySlotStateMap = {};
        var slotStatesMapKey;
        for (var i = 0; i < Object.keys(slotStatesMap).length; i++) {
            slotStatesMapKey = Object.keys(slotStatesMap)[i];
            emptySlotStateMap[slotStatesMapKey] = "";
        }

        var emptyDataRecord = {
            createdBy: "",
            createdDate: "",
            lastModifiedBy: "",
            lastModifiedDate: "",
            id: null,
            sortNum: null,
            dstId: "",
            dialogActionType: "",
            transitionFunction: "",
            slotStatesMap: emptySlotStateMap
        };
        this.state.data.unshift(emptyDataRecord);
        this.state.disableAdd = true;
        this.setState(this.state);
        this.loadDataForAddNewRecord(emptyDataRecord);
    }

    loadDataForAddNewRecord(emptyDataRecord) {
        let transitionController = this;
        var loadData = {}
        $.ajax({
            url: "/api/dsm-transition/" + transitionController.props.location.state.dstId,
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    transitionController.state.data = res.result;
                    // for (var i = 0; i < res.result.length; i++) {
                    //     res.result[i].slotStatesMap["function"] = res.result[i].transitionFunction;
                    //     res.result[i].slotStatesMap["id"] = res.result[i].id;
                    transitionController.state.data.unshift(emptyDataRecord);
                    // }

                    transitionController.setState(transitionController.state);
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    // ----------------------------GET SLOT VALUE TYPE----------------------------------
    getSlotValueType = () => {
        let transitionController = this;
        $.ajax({
            url: "/api/dsm-slot-value-types",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        transitionController.state.slotValueType.push(res.result[i].name)
                    }
                    transitionController.setState({ showLoader: true });
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    //---------------------------------GET DSM TRANSITION TYPES-----------------------------------
    getDsmTransitionTypes = () => {
        let transitionController = this;
        $.ajax({
            url: "/api/dsm-transition-types",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        transitionController.state.dsmTransitionTypes.push(res.result[i].name)
                    }
                    transitionController.setState({ showLoader: true });
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    //ADD NEW TRANSITION 
    saveCell(props, e) {
        var transitionData = this.state.data[props.index].slotStatesMap;
        var functionValue = this.state.data[props.index].transitionFunction;
        var dstId = this.props.location.state.dstId;
        var slotStatesMapKey;
        var isAnyFieldEmpty = false;
        for (var i = 0; i < Object.keys(transitionData).length; i++) {
            slotStatesMapKey = Object.keys(transitionData)[i];
            if (transitionData[slotStatesMapKey] === "" || functionValue === "") {
                isAnyFieldEmpty = true;
                break;
            }
        }
        if (isAnyFieldEmpty) {
            this.notifyEmptyFields();
        } else {

            var newDsmRuleRecord = {
                dstId: dstId,
                sortNum: this.state.data.length,
                slotStatesMap: transitionData,
                transitionFunction: functionValue
            };
            var transitionController = this;
            $.ajax({
                url: "/api/dsm-transition",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(newDsmRuleRecord),
                processData: false,
                success: function (res) {
                    if (res.success === true) {
                        transitionController.state.disableAdd = false;
                        transitionController.loadData();
                        transitionController.notifySucces("Transition Rule Added Successfully");
                    } else {
                        transitionController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    updateCell = (props, e) => {
        var dstId = this.props.location.state.dstId;

        var slotStatesMap = {};
        for (var i = 0; i < Object.keys(this.state.emptyDataRecord.slotStatesMap).length; i++) {
            var key = Object.keys(this.state.emptyDataRecord.slotStatesMap)[i]
            slotStatesMap[key] = props.original.slotStatesMap[key];
        }
        var transitionData = slotStatesMap;
        //this.state.data[props.index].slotStatesMap;
        var functionValue = this.state.data[props.index].transitionFunction;

        var isAnyFieldEmpty = false;
        var slotStatesMapKey;
        for (var i = 0; i < Object.keys(transitionData).length; i++) {
            slotStatesMapKey = Object.keys(transitionData)[i];
            if (transitionData[slotStatesMapKey] === "" || functionValue === "") {
                isAnyFieldEmpty = true;
                break;
            }
        }

        if (isAnyFieldEmpty) {
            this.notifyEmptyFields();
        } else {
            var dsmRuleRecord = {
                id: props.original.id,
                sortNum: props.original.sortNum,
                dstId: dstId,
                slotStatesMap: transitionData,
                transitionFunction: functionValue
            };

            var transitionController = this;
            $.ajax({
                url: "/api/dsm-transition",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(dsmRuleRecord),
                processData: false,
                success: function (res) {
                    if (res.success === true) {
                        transitionController.state.editedId = "-1";
                        transitionController.setState(transitionController.state);
                        transitionController.notifySucces("Transition Rule Updated Successfully")
                    } else {
                        transitionController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    editCell = (props, e) => {
        this.currentSrc = this.src;
        this.state.editedId = props.original.id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    deleteApiFunc = (id) => {
        let transitionController = this;
        $.ajax({
            url: "/api/dsm-transition/" + id,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    transitionController.state.deleteRow = true;
                    transitionController.state.hideDeletePopup = false;
                    transitionController.setState(transitionController.state)
                    transitionController.loadData();
                    transitionController.notifySucces("Transition Rule Deleted Successfully")
                    var sortNumMap = {};
                    for (var i = 0; i < transitionController.state.data.length; i++) {
                        sortNumMap[transitionController.state.data[i].id] = i + 1;
                    }
                    transitionController.saveSortNumAfterDelete(sortNumMap);
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFirstRowMoveWarn() {
        toast.dismiss();
        toast(<b><img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;This is the first row and it cannot be moved up</b>, {
            position: "top-center"
        });
    }

    saveSortNumAfterDelete = (sortNumMap) => {
        var transitionController = this;
        $.ajax({
            url: "/api/dsm-transition/",
            async: false,
            method: 'PATCH',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': "application/json"
            },
            data: JSON.stringify(sortNumMap),
            success: function (res) {
                if (res.success === true) {
                    return true;
                } else {
                    return false;
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    changePriorityOfRow = (props, e) => {
        if (props.index === 0) {
            this.notifyFirstRowMoveWarn();
        } else {
            var data = this.state.data;
            var tmp = data[props.index];
            data[props.index] = data[props.index - 1];
            data[props.index - 1] = tmp;
            // var dataCloned = Object.assign({}, data);
            this.state.data = data;
            // this.setState(this.state);

            var transitionData = this.state.data[props.index].slotStatesMap;
            var functionValue = this.state.data[props.index].transitionFunction;
            var dstId = this.props.location.state.dstId;
            var newDsmRuleRecord = {
                id: this.state.data[props.index].id,
                dstId: dstId,
                sortNum: this.state.data[props.index - 1].sortNum,
                slotStatesMap: transitionData,
                transitionFunction: functionValue
            };
            var savedCurrentCell = this.saveSwappedCell(newDsmRuleRecord);

            if (savedCurrentCell) {
                var transitionData = this.state.data[props.index - 1].slotStatesMap;
                var functionValue = this.state.data[props.index - 1].transitionFunction;
                var dstId = this.props.location.state.dstId;
                // if (this.validateCells(props.original.name, props.original.description)) {
                newDsmRuleRecord = {
                    id: this.state.data[props.index - 1].id,
                    dstId: dstId,
                    sortNum: this.state.data[props.index].sortNum,
                    slotStatesMap: transitionData,
                    transitionFunction: functionValue
                };
                this.saveSwappedCell(newDsmRuleRecord);
            }
            this.loadData();
        }
    }


    saveSwappedCell = (newDsmRuleRecord) => {
        var transitionController = this;
        var response = false;
        $.ajax({
            url: "/api/dsm-transition",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(newDsmRuleRecord),
            processData: false,
            success: function (res) {
                if (res.success === true) {
                    response = true;
                } else {
                    transitionController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        })
        return response;
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.state.disableAdd = false;
        this.loadData()
    }

    notifySucces(displayContent) {
        toast.dismiss();
        toast(<b><img src="./assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{displayContent}</b>,
            {
                position: "top-center",
            });
    }

    goBack = () => {
        this.props.history.push({
            pathname: "/projectmgmt/nlutab/dsm",
            state: { goBackToDsm: true }
        });
    }

    // saveIdAndIndex = (props) => {
    //     const id = props.original.id;
    //     this.state.indexAndIdList[id] = props.index;
    // }

    render() {
        const data = this.state.data;
        if (true) {
            if (this.numOfRendering <= 1) {
                // this.columns = this.getColumns();
                if (this.columns.length === 0) {
                    return null;
                }
                this.numOfRendering++;
            }
        }

        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ marginLeft: '400px' }}
                />
                <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>
                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="./assets/css/react-table-height.css" />

                    {/* for Combobox styling */}
                    <link rel="stylesheet" href="./assets/css/combobox-style.css" />

                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />

                    {/* <div className="content-header"> */}
                    {/* <div className="container-fluid"> */}


                    <ToastContainer className="Toast-at-center" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-2" style={{ marginTop: "16px" }}>
                                <img className="cursor-change" src="./assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBack}
                                />
                            </div>
                            <div className="col-sm-6">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginLeft: '202px', marginTop: '18px'
                                }}>Transition for the skill {this.props.location.state.skillName}</h6>
                            </div>

                            <div className="col-sm-4" Align='right'>
                                {/* Save Priority Order Button */}
                                {/* <button className="btn action-button"
                            onClick={this.savePriority}>Save Priority Order</button> */}

                                {/* Add Row Button */}
                                <button
                                    className="btn action-button" title="Add">
                                    <img src="./assets/images/add_white_24dp.png"
                                        onClick=
                                        {this.state.disableAdd ? this.notifyEmptyFields : this.addRow.bind(this)} />
                                </button>

                                {/* Refresh Page */}
                                <button className="btn action-button"
                                    onClick={this.refreshData} title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">
                                        <ReactTable
                                            data={this.state.data}
                                            columns={this.columns}
                                            showPagination={false}
                                            pageSize={this.state.data.length < 10 ? 10 : this.state.data.length}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*Dialog Component For Deletion Confirmation*/}
                    <DialogComponent width='400px' animationSettings={this.settings}
                        header='Transitions' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog}
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete this Transition Rule? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                    {/* </div>
                            </div>
                        </div>
                    </div> */}
                    {/* </div> */}
                </div >
            </div>

        )
    }
}
export default Transition;





// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/transition/transition.js